<template>
    <Modal v-model="show" title="申请开具发票" @on-cancel="handleCancel" width="800">
        <Spin v-if="loading" size="large" fix></Spin>
        <Row :gutter="16">
            <Col span="24">
            <Form ref="form" :model="form" :rules="dynamicRules" label-position="right" :label-width="150">
                <Row :gutter="16">
                    <Col span="24" class-name="invoiceField">
                    <FormItem label="开具类型:" prop="invoiceBuyerType">
                        <Select v-model="form.invoiceBuyerType" placeholder="请选择开具类型"
                            @on-change="onInvoiceBuyerTypeChange" disabled>
                            <Option value="企业">企业</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="24" class-name="invoiceField">
                    <FormItem label="发票类型:" prop="invoiceLine1">
                        <RadioGroup v-model="form.invoiceLine1" @on-change="onInvoiceLine1Change">
                            <Radio label="数电普票"></Radio>
                            <Radio v-if="form.invoiceBuyerType === '企业'" label="数电专票"></Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="24" class-name="invoiceField">
                    <FormItem label="介质类型:" prop="invoiceLine2">
                        <RadioGroup v-model="form.invoiceLine2">
                            <Radio label="电子发票"></Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="24" class-name="invoiceField">
                    <FormItem label="发票抬头:" prop="invoiceBuyerName">
                        <Input v-model="form.invoiceBuyerName" placeholder="请输入发票抬头" />
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col v-if="form.invoiceBuyerType === '企业'" span="24" class-name="invoiceField">
                    <FormItem label="统一社会信用代码:" prop="invoiceBuyerTaxNum">
                        <Input v-model="form.invoiceBuyerTaxNum" placeholder="请输入统一社会信用代码" />
                    </FormItem>
                    </Col>
                    <Col v-if="['数电专票'].includes(form.invoiceLine1)" span="24" class-name="invoiceField">
                    <FormItem label="开户银行名称:" prop="invoiceBuyerBank">
                        <Input v-model="form.invoiceBuyerBank" placeholder="请输入开户银行名称（选填）" />
                    </FormItem>
                    </Col>
                    <Col v-if="['数电专票'].includes(form.invoiceLine1)" span="24" class-name="invoiceField">
                    <FormItem label="基本开户账号:" prop="invoiceBuyerAccount">
                        <Input v-model="form.invoiceBuyerAccount" placeholder="请输入基本开户账号（选填）" />
                    </FormItem>
                    </Col>
                    <Col v-if="['数电专票'].includes(form.invoiceLine1)" span="24" class-name="invoiceField">
                    <FormItem label="注册场所地址:" prop="invoiceBuyerAddress">
                        <Input v-model="form.invoiceBuyerAddress" placeholder="请输入注册场所地址（选填）" />
                    </FormItem>
                    </Col>
                    <Col v-if="['数电专票'].includes(form.invoiceLine1)" span="24" class-name="invoiceField">
                    <FormItem label="注册固定电话:" prop="invoiceBuyerTel">
                        <Input v-model="form.invoiceBuyerTel" placeholder="请输入注册固定电话（选填）" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            </Col>
        </Row>
        <div slot="footer" style="display: flex;justify-content: space-between;align-items: center;">
            <div>
                <span>待开票金额：{{ form.invoiceValue }}</span>
                <span>（货款：{{ form.invoiceProductValue }},运费：{{ form.invoiceDeliveryFee }},包装费：{{ form.invoicePackageFee
                }})</span>
            </div>
            <div>
                <Button type="primary" :loading="loading" @click="onApplyInvoice">
                    保存
                </Button>
                <Button v-if="form.isCanSubmit" type="info" :loading="loading" @click="preViewInvoice">
                    预览
                </Button>
                <Button @click="handleCancel">
                    取消
                </Button>
            </div>
        </div>
        <invoicePreviewModal ref="invoicePreviewModal" @invoice-submitted="onInvoiceSubmittedFromPreview"
            @invoice-submit-error="onInvoiceSubmitErrorFromPreview" />
    </Modal>
</template>

<script>
import invoicePreviewModal from "./invoice-preview-new.vue";
import { getInvoiceAccount, applyInvoice, webGetInvoice, getPendingInvoiceAmount } from "@/api/modules/finance-management/invoice";
export default {
    name: "InvoiceModal",
    components: {
        invoicePreviewModal
    },
    props: {
    },
    data() {
        return {
            show: false,
            loading: false,
            currentDeliveryUuid: '', // 本地存储的deliveryUuid，避免直接修改prop
            apiCallTimer: null, // API调用防抖定时器
            savedInvoiceAccount: null, // 保存从API获取的原始发票账户信息
            form: {
                // 发票抬头信息
                invoiceBuyerType: '企业', // 企业 | 个人
                invoiceBuyerName: null, // 发票抬头
                invoiceBuyerTaxNum: null, // 统一社会信用代码
                invoiceBuyerBank: null, // 开户银行名称
                invoiceBuyerAccount: null, // 基本开户账号
                invoiceBuyerAddress: null, // 注册场所地址
                invoiceBuyerTel: null, // 注册固定电话

                // 发票类型与内容
                invoiceLine1: '数电普票', // 数电普票 | 数电专票
                invoiceLine2: '电子发票', // 电子发票
                invoiceCode: '', // (新增) 发票代码

                // 发票金额与费用
                invoiceProductValue: 0, // (新增) 商品价值
                invoiceValue: 0, // (新增) 发票总金额
                invoiceDeliveryFee: 0, // 发票邮寄费
                invoicePackageFee: 0, // (新增) 包装费

                // 发票流转与状态
                invoiceUuid: null, // 发票UUID，用于预览和提交
                invoiceSerialNum: null, // (新增) 发票流水号
                invoiceStatus: null, // (新增) 发票状态

                // 邮寄信息
                invoiceDeliveryAddress: null, // 邮寄地址
                invoiceDeliveryUuidList: null, // (新增) 邮寄UUID列表

                // 申请人信息
                invoiceUserUuid: null, // 用户UUID
                invoiceUserApplier: null, //  用户申请人
                invoiceUserAppliedAt: null, //用户申请时间
                invoiceAccounterApplier: '', // 财务申请人
                invoiceAccounterAppliedAt: null, // 财务申请时间

                isCanSubmit: false
            },
            rules: {
                invoiceBuyerType: [{ required: true, message: "请选择开具类型", trigger: "change" }],
                invoiceLine1: [{ required: true, message: "请选择发票类型", trigger: "change" }],
                invoiceLine2: [{ required: true, message: "请选择介质类型", trigger: "change" }],
                invoiceBuyerName: [{ required: true, message: "请填写发票抬头", trigger: "blur" }],
                invoiceBuyerTaxNum: [
                    { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
                    { pattern: /^[0-9A-Z]{18}$/, message: "统一社会信用代码格式不正确", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        // 动态验证规则
        dynamicRules() {
            const rules = { ...this.rules };

            // 企业类型的必填字段
            if (this.form.invoiceBuyerType === '企业') {
                rules.invoiceBuyerTaxNum = [
                    { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
                    { pattern: /^[0-9A-Z]{18}$/, message: "统一社会信用代码格式不正确", trigger: "blur" }
                ];
            }
            else {
                delete rules.invoiceBuyerTaxNum;
            }

            // 专票字段不再设为必填，移除必填验证
            // 这些字段现在是可选的，用户可以根据需要填写
            if (this.form.invoiceLine1 === '数电专票') {
                // 移除 required: true，只保留可选的验证规则
                // 如果需要其他验证（如格式验证），可以在这里添加
            }
            else {
                // 确保这些字段在任何情况下都没有验证规则
                delete rules.invoiceBuyerBank;
                delete rules.invoiceBuyerAccount;
                delete rules.invoiceBuyerAddress;
                delete rules.invoiceBuyerTel;
            }

            return rules;
        }
    },
    methods: {
        showModal(deliveryUuid) {
            this.currentDeliveryUuid = deliveryUuid;
            this.resetForm();

            // 打开弹窗后立即获取发票账户信息
            this.getInvoiceAccount();
            this.getPendingInvoiceAmount(deliveryUuid);
            this.show = true;
        },
        // 新增隐藏弹窗方法
        hideModal() {
            this.show = false; // 直接控制弹窗隐藏
            // 延迟重置表单，确保弹窗关闭动画完成
            this.$nextTick(() => {
                this.resetForm();
            });
        },
        handleCancel() {
            this.$emit("cancel");
            this.hideModal();
        },
        handleOk() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                // 提交数据，包含 deliveryUuid
                const payload = {
                    deliveryUuid: this.currentDeliveryUuid,
                    ...this.form
                };
                console.log('子组件准备提交的数据:', payload);
                this.$emit("submit", payload);
                // 关闭弹窗
                this.hideModal();
            });
        },
        getPendingInvoiceAmount(deliveryUuid) {
            getPendingInvoiceAmount({ deliveryUuidList: [deliveryUuid] }).then(res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.form.invoiceProductValue = data.productFee // (新增) 商品价值
                    this.form.invoiceValue = data.totalMoney // (新增) 发票总金额
                    this.form.invoiceDeliveryFee = data.deliveryFee // 发票邮寄费
                    this.form.invoicePackageFee = data.packageFee // (新增) 包装费
                }
            })
        },
        getInvoiceAccount() {
            this.loading = true;
            getInvoiceAccount({ deliveryUuid: this.currentDeliveryUuid }).then(res => {
                this.loading = false;
                if (res.code === 200 || res.code === 0) {
                    const invoiceAccountModel = res.data.invoiceAccountModel;
                    const isCanSubmit = res.data.isCanSubmit;
                    console.log('获取到的发票账户信息:', invoiceAccountModel);
                    if (invoiceAccountModel) {
                        // 保存原始数据，用于后续类型切换时恢复
                        this.savedInvoiceAccount = { ...invoiceAccountModel };

                        // 智能填充表单数据，保留用户已输入的数据
                        this.form.invoiceBuyerName = this.form.invoiceBuyerName || invoiceAccountModel.invoiceAccountBuyerName || '';
                        this.form.invoiceBuyerTaxNum = this.form.invoiceBuyerTaxNum || invoiceAccountModel.invoiceAccountBuyerTaxNum || '';
                        this.form.invoiceBuyerBank = this.form.invoiceBuyerBank || invoiceAccountModel.invoiceAccountBuyerBank || '';
                        this.form.invoiceBuyerAccount = this.form.invoiceBuyerAccount || invoiceAccountModel.invoiceAccountBuyerAccount || '';
                        this.form.invoiceBuyerAddress = this.form.invoiceBuyerAddress || invoiceAccountModel.invoiceAccountBuyerAddress || '';
                        this.form.invoiceBuyerTel = this.form.invoiceBuyerTel || invoiceAccountModel.invoiceAccountBuyerTel || '';
                        this.form.invoiceDeliveryAddress = invoiceAccountModel.invoiceAccountMailAddress || '';
                        this.form.invoiceBuyerType = invoiceAccountModel.invoiceAccountBuyerType || '企业';
                        this.form.invoiceStatus = invoiceAccountModel.invoiceAccountStatus || null;
                        this.form.invoiceCode = invoiceAccountModel.invoiceAccountCode || '';
                        this.form.isCanSubmit = isCanSubmit;
                        this.form.invoiceUserUuid = invoiceAccountModel.invoiceAccountUserUuid;

                        // 显式触发校验，消除由于程序化赋值导致的“请填写”提示残留
                        this.$nextTick(() => {
                            if (this.dynamicRules.invoiceBuyerName) {
                                this.$refs.form.validateField('invoiceBuyerName');
                            }
                            if (this.dynamicRules.invoiceBuyerTaxNum) {
                                this.$refs.form.validateField('invoiceBuyerTaxNum');
                            }
                        });
                    }
                }
                else {
                    console.warn('获取发票账户信息返回异常状态:', res.code, res.message);
                }
            }).catch(err => {
                this.loading = false;
                console.error('获取发票账户信息失败:', err);
                // 网络错误或API异常时不显示错误提示，避免打扰用户
                // 用户可以手动填写信息
            });
        },
        // 开具类型变更处理
        onInvoiceBuyerTypeChange(value) {
            if (value === '个人') {
                this.form.invoiceLine1 = '数电普票';
                this.form.invoiceLine2 = '电子发票';
                // 切换到个人时，清空企业相关字段，但保存当前值以便恢复
                this.form.invoiceBuyerTaxNum = '';
            }
            else if (value === '企业') {
                // 切换回企业时，恢复保存的统一社会信用代码
                if (this.savedInvoiceAccount && this.savedInvoiceAccount.invoiceAccountBuyerTaxNum) {
                    // 只有当当前字段为空时才恢复，避免覆盖用户输入
                    if (!this.form.invoiceBuyerTaxNum) {
                        this.form.invoiceBuyerTaxNum = this.savedInvoiceAccount.invoiceAccountBuyerTaxNum;
                    }
                }
                // 同时恢复其他企业相关字段（如果用户没有输入的话）
                if (this.savedInvoiceAccount) {
                    if (!this.form.invoiceBuyerBank && this.savedInvoiceAccount.invoiceAccountBuyerBank) {
                        this.form.invoiceBuyerBank = this.savedInvoiceAccount.invoiceAccountBuyerBank;
                    }
                    if (!this.form.invoiceBuyerAccount && this.savedInvoiceAccount.invoiceAccountBuyerAccount) {
                        this.form.invoiceBuyerAccount = this.savedInvoiceAccount.invoiceAccountBuyerAccount;
                    }
                    if (!this.form.invoiceBuyerAddress && this.savedInvoiceAccount.invoiceAccountBuyerAddress) {
                        this.form.invoiceBuyerAddress = this.savedInvoiceAccount.invoiceAccountBuyerAddress;
                    }
                    if (!this.form.invoiceBuyerTel && this.savedInvoiceAccount.invoiceAccountBuyerTel) {
                        this.form.invoiceBuyerTel = this.savedInvoiceAccount.invoiceAccountBuyerTel;
                    }
                }
            }
        },
        // 发票类型变更处理
        onInvoiceLine1Change(value) {
            // 防抖处理，避免频繁调用API
            if (this.apiCallTimer) {
                clearTimeout(this.apiCallTimer);
            }

            if (value === '数电普票') {
                this.form.invoiceLine2 = '电子发票';
                // 清空专票特有字段
                this.clearSpecialInvoiceFields();
            }
            else if (value === '数电专票') {
                this.form.invoiceLine2 = '电子发票';
                // 专票可能需要调用API获取更多信息，使用防抖
                this.apiCallTimer = setTimeout(() => {
                    this.getInvoiceAccount();
                }, 300);
            }
        },
        // 清空专票特有字段
        clearSpecialInvoiceFields() {
            this.form.invoiceBuyerBank = '';
            this.form.invoiceBuyerAccount = '';
            this.form.invoiceBuyerAddress = '';
            this.form.invoiceBuyerTel = '';
        },
        resetForm() {
            // 重置到默认值
            this.form = {
                // 发票抬头信息
                invoiceBuyerType: '企业', // 企业 | 个人
                invoiceBuyerName: '', // 发票抬头
                invoiceBuyerTaxNum: '', // 统一社会信用代码
                invoiceBuyerBank: '', // 开户银行名称
                invoiceBuyerAccount: '', // 基本开户账号
                invoiceBuyerAddress: '', // 注册场所地址
                invoiceBuyerTel: '', // 注册固定电话

                // 发票类型与内容
                invoiceLine1: '数电普票', // 数电普票 | 数电专票
                invoiceLine2: '电子发票', // 电子发票
                invoiceCode: '', // 发票代码

                // 发票金额与费用
                invoiceProductValue: 0, // 商品价值
                invoiceValue: 0, // 发票总金额
                invoiceDeliveryFee: 0, // 发票邮寄费
                invoicePackageFee: 0, // 包装费

                // 发票流转与状态
                invoiceUuid: '', // 发票UUID，用于预览和提交
                invoiceSerialNum: '', // 发票流水号
                invoiceStatus: null, // 发票状态

                // 邮寄信息
                invoiceDeliveryAddress: '', // 邮寄地址
                invoiceDeliveryUuidList: '', // 邮寄UUID列表

                // 申请人信息
                invoiceUserUuid: null, // 用户UUID
                invoiceUserApplier: null, // 用户申请人
                invoiceUserAppliedAt: null, // 用户申请时间
                invoiceAccounterApplier: '', // 财务申请人
                invoiceAccounterAppliedAt: null // 财务申请时间
            };

            // 清除保存的发票账户信息
            this.savedInvoiceAccount = null;

            // 清除校验状态 - 添加安全检查
            if (this.$refs.form && this.$refs.form.resetFields) {
                this.$nextTick(() => {
                    if (this.$refs.form && this.$refs.form.resetFields) {
                        this.$refs.form.resetFields();
                    }
                });
            }
        },
        onApplyInvoice() {
            // 表单验证
            this.$refs.form.validate(valid => {
                if (!valid) return;

                this.loading = true;
                const submitData = {
                    ...this.form,
                    invoiceDeliveryUuidList: [this.currentDeliveryUuid]

                };

                applyInvoice(submitData).then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        // 保存成功后更新表单状态
                        if (res.data && res.data.invoiceUuid) {
                            this.form.invoiceUuid = res.data.invoiceUuid;
                        }
                        this.$Modal.success({
                            title: "保存成功",
                            content: "请预览发票，确认无误后提交。",
                            onOk: () => {
                                // 确认后自动跳转到预览界面
                                this.preViewInvoice();
                            }
                        });
                    }
                    else {
                        this.$Message.error(res.message || '保存失败，请重试');
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error('保存发票申请失败:', err);
                    this.$Message.error('保存失败，请稍后重试');
                });
                this.loading = false;
            });
        },
        preViewInvoice() {
            webGetInvoice({ deliveryUuidList: this.currentDeliveryUuid.split(','), invoiceUuid: this.form.invoiceUuid }).then(res => {
                if (res.code === 0) {
                    this.$refs.invoicePreviewModal.showModal(res.data);
                }
                else {
                    this.$Message.error(res.message || '获取发票预览失败');
                    console.error('获取发票预览失败:', res);
                }
            }).catch(err => {
                this.$Message.error('获取发票预览失败，请稍后重试');
                console.error('获取发票预览失败:', err);
            });
        },
        onInvoiceSubmittedFromPreview() {
            console.log('发票提交成功回传');
            this.hideModal();
            this.$emit('invoice-submitted');
        },
        onInvoiceSubmitErrorFromPreview() {
            console.error('发票提交失败回传');
            this.$Message.error('提交开票失败');
            this.$emit('invoice-submit-error');
        }
    },
    beforeDestroy() {
        // 组件销毁时清理状态
        // 清理防抖定时器
        if (this.apiCallTimer) {
            clearTimeout(this.apiCallTimer);
            this.apiCallTimer = null;
        }

        // 直接重置数据，避免调用可能有问题的DOM方法
        this.currentDeliveryUuid = '';
        this.savedInvoiceAccount = null;
        this.form = {
            invoiceBuyerType: '',
            invoiceLine1: '数电普票',
            invoiceLine2: '电子发票',
            invoiceBuyerName: '',
            invoiceBuyerTaxNum: '',
            invoiceBuyerBank: '',
            invoiceBuyerAccount: '',
            invoiceBuyerAddress: '',
            invoiceBuyerTel: '',
            invoiceDeliveryAddress: '',
            invoiceUuid: ''
        };
    }
};
</script>

<style scoped>
/* 简单布局微调 */
.ivu-modal-body .ivu-form {
    padding-top: 6px;
}

/* 发票字段样式 */
.invoiceField {
    margin-bottom: 16px;
}

.ivu-form-item {
    margin-bottom: 16px;
}

.ivu-modal-body {
    max-height: 500px;
    overflow-y: auto;
}
</style>
